import { render, staticRenderFns } from "./WidgetMyReleaseNotes.vue?vue&type=template&id=8ff5d348&scoped=true"
import script from "./WidgetMyReleaseNotes.vue?vue&type=script&lang=js"
export * from "./WidgetMyReleaseNotes.vue?vue&type=script&lang=js"
import style0 from "./WidgetMyReleaseNotes.vue?vue&type=style&index=0&id=8ff5d348&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff5d348",
  null
  
)

export default component.exports